import { useEffect } from 'react';
import { useBusinessDocumentsContext } from '../context/BusinessDocumentsContext';
import type { PaymentInfoData } from '../types';

export const useSetBusinessDocumentsData = (
  data: PaymentInfoData | undefined
) => {
  const { setData } = useBusinessDocumentsContext();

  useEffect(() => {
    if (!data) return;
    setData(data);
  }, [data, setData]);
};
